module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages w-100"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Datei")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Folie")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_c('button', {
    on: {
      "click": _vm.getFiles
    }
  }, [_vm._v("Datein neu laden")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.files), function(file) {
    return _c('tr', {
      key: file.id
    }, [_c('td', [_vm._v(_vm._s(file.filename))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.matches[file.id]),
        expression: "matches[file.id]"
      }],
      staticClass: "w-100",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.matches, file.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.save(file.id)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("Nicht Verwenden")]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
      return [(page.type !== 'questiongroup') ? _c('option', {
        domProps: {
          "value": page.id
        }
      }, [_vm._v("\n                            " + _vm._s(page.name) + "\n                        ")]) : _vm._e(), _vm._v(" "), (page.type === 'questiongroup') ? _c('optgroup', {
        attrs: {
          "label": page.name
        }
      }, _vm._l((page.questiongroup.questions), function(question) {
        return _c('option', {
          domProps: {
            "value": page.id + '|' + question.id
          }
        }, [_vm._v("\n                                " + _vm._s(question.text) + "\n                            ")])
      }), 0) : _vm._e()]
    })], 2)])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e6def27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Projectfilemanager.vue
// module id = 105
// module chunks = 0